// countries.js

export const countryOptions = [
    // Países europeos de habla española
    { key: "es", value: "es", text: "España" },
  
    // Países latinoamericanos de habla española
    { key: "ar", value: "ar", text: "Argentina" },
    { key: "bo", value: "bo", text: "Bolivia" },
    { key: "cl", value: "cl", text: "Chile" },
    { key: "co", value: "co", text: "Colombia" },
    { key: "cr", value: "cr", text: "Costa Rica" },
    { key: "cu", value: "cu", text: "Cuba" },
    { key: "do", value: "do", text: "República Dominicana" },
    { key: "ec", value: "ec", text: "Ecuador" },
    { key: "sv", value: "sv", text: "El Salvador" },
    { key: "gt", value: "gt", text: "Guatemala" },
    { key: "hn", value: "hn", text: "Honduras" },
    { key: "mx", value: "mx", text: "México" },
    { key: "ni", value: "ni", text: "Nicaragua" },
    { key: "pa", value: "pa", text: "Panamá" },
    { key: "py", value: "py", text: "Paraguay" },
    { key: "pe", value: "pe", text: "Perú" },
    { key: "pr", value: "pr", text: "Puerto Rico" },
    { key: "uy", value: "uy", text: "Uruguay" },
    { key: "ve", value: "ve", text: "Venezuela" },
  
    // Completa lista de países europeos
    { key: "al", value: "al", text: "Albania" },
    { key: "ad", value: "ad", text: "Andorra" },
    { key: "am", value: "am", text: "Armenia" },
    { key: "at", value: "at", text: "Austria" },
    { key: "az", value: "az", text: "Azerbaiyán" },
    { key: "by", value: "by", text: "Bielorrusia" },
    { key: "be", value: "be", text: "Bélgica" },
    { key: "ba", value: "ba", text: "Bosnia y Herzegovina" },
    { key: "bg", value: "bg", text: "Bulgaria" },
    { key: "hr", value: "hr", text: "Croacia" },
    { key: "cy", value: "cy", text: "Chipre" },
    { key: "cz", value: "cz", text: "República Checa" },
    { key: "dk", value: "dk", text: "Dinamarca" },
    { key: "ee", value: "ee", text: "Estonia" },
    { key: "fi", value: "fi", text: "Finlandia" },
    { key: "fr", value: "fr", text: "Francia" },
    { key: "ge", value: "ge", text: "Georgia" },
    { key: "de", value: "de", text: "Alemania" },
    { key: "gr", value: "gr", text: "Grecia" },
    { key: "hu", value: "hu", text: "Hungría" },
    { key: "is", value: "is", text: "Islandia" },
    { key: "ie", value: "ie", text: "Irlanda" },
    { key: "it", value: "it", text: "Italia" },
    { key: "kz", value: "kz", text: "Kazajistán" },
    { key: "xk", value: "xk", text: "Kosovo" },
    { key: "lv", value: "lv", text: "Letonia" },
    { key: "li", value: "li", text: "Liechtenstein" },
    { key: "lt", value: "lt", text: "Lituania" },
    { key: "lu", value: "lu", text: "Luxemburgo" },
    { key: "mt", value: "mt", text: "Malta" },
    { key: "md", value: "md", text: "Moldavia" },
    { key: "mc", value: "mc", text: "Mónaco" },
    { key: "me", value: "me", text: "Montenegro" },
    { key: "nl", value: "nl", text: "Países Bajos" },
    { key: "no", value: "no", text: "Noruega" },
    { key: "pl", value: "pl", text: "Polonia" },
    { key: "pt", value: "pt", text: "Portugal" },
    { key: "ro", value: "ro", text: "Rumanía" },
    { key: "ru", value: "ru", text: "Rusia" },
    { key: "sm", value: "sm", text: "San Marino" },
    { key: "rs", value: "rs", text: "Serbia" },
    { key: "sk", value: "sk", text: "Eslovaquia" },
    { key: "si", value: "si", text: "Eslovenia" },
    { key: "se", value: "se", text: "Suecia" },
    { key: "ch", value: "ch", text: "Suiza" },
    { key: "tr", value: "tr", text: "Turquía" },
    { key: "ua", value: "ua", text: "Ucrania" },
    { key: "gb", value: "gb", text: "Reino Unido" },
  
    // Potencias mundiales y países emergentes adicionales
    { key: "us", value: "us", text: "Estados Unidos" },
    { key: "cn", value: "cn", text: "China" },
    { key: "jp", value: "jp", text: "Japón" },
    { key: "in", value: "in", text: "India" },
    { key: "br", value: "br", text: "Brasil" },
    { key: "kr", value: "kr", text: "Corea del Sur" },
    { key: "sa", value: "sa", text: "Arabia Saudita" },
    { key: "za", value: "za", text: "Sudáfrica" },
    { key: "ae", value: "ae", text: "Emiratos Árabes Unidos" },
    { key: "id", value: "id", text: "Indonesia" },
    { key: "ng", value: "ng", text: "Nigeria" }
  ];
